import { Attributes, ValueObject, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingFileSpecLookup extends ValueObject {

    public staticServiceProviderFileGroupingFileSpecId: number = 0;

    @Rules.Required()
    @Attributes.Display("File Spec")
    public staticFileSpecId: number = 0;

    @Rules.Required()
    @Attributes.Display("Broker")
    public staticServiceProviderFileGroupingId: number = 0;

    public fileType: string = "";
    
    @Attributes.Date()
    public activeStartDate: Date | null = null;

    @Attributes.Date()
    public activeEndDate: Date | null = null;

    public columnCount: number = 0;

    public stockbrokerName: string = "";

    @Rules.StringLength(200)
    @Rules.Required()
    public fileNameConvention: string = "";

    public ignoreFileInd: boolean = false;

    public isCriticalFileInd: boolean = false;

    @Rules.StringLength(3)
    public processSortOrder: string | null = null;

    public fileTypeConcatenated: string | null = null;
}